import * as React from 'react';
import { ComponentProps, ButtonSecondary, Validation, ValidationLevel, ValidationProps } from 'ui';
import styles from './add-new-case-button.scss';
import { NavigateToNewDraftInjectedProps, withNavigateToNewDraft } from 'app/area/case/components/enhancers/navigate-to-new-draft';
import { containerFactory } from 'app/infrastructure/redux/container-factory';
import { actionCreators } from 'app/area/case/draft/actions';
import { STATE } from 'app/constants';

interface AddNewCaseButtonProps extends ComponentProps, NavigateToNewDraftInjectedProps {
  readOnly?: boolean;
  validation?: ValidationProps;
  doWhenIdle: (func: any, info: string)=>void;
  textSavingInfo: string;
}

class AddNewCaseButtonComponent extends React.PureComponent<AddNewCaseButtonProps> {
  public static statePath: string = STATE.app;

  private handleClick = (e?: any) => {
    const {doWhenIdle, navigateToNewDraft, textSavingInfo} = this.props;
    e && e.preventDefault();

    doWhenIdle && doWhenIdle(navigateToNewDraft, textSavingInfo) ;
  };

  public render() {
    const {
      componentId,
      className,
      label,
      readOnly,
      validation
    } = this.props;

    const {
      buttonWrapper
    } = styles;

    const errorParams = {
      level: ValidationLevel.error,
      messages: [{level: ValidationLevel.error,
                  message: validation && validation.messages && validation.messages.map(m=>`${m.label}: ${m.message}`).join('\n')}]
    };

    const hasValidationErrors = (validation && !!validation.messages.length);
    const validationErrorStyle = hasValidationErrors && styles.validationError;

    return (
      readOnly ? null :
      <div id={componentId} className={`${styles.buttonContainer} ${className}`}>
        <div  className={`${buttonWrapper} ${className}`}>
          <ButtonSecondary id={`${componentId}-button`} classNames={validationErrorStyle} onClick={this.handleClick}>
            {label && label.required && <span className="asterisk-required">* </span>}
            {label && label.text}
          </ButtonSecondary>
          {validation && <Validation {...errorParams}/>}
        </div>
      </div>
    );
  }
}

const c = containerFactory(withNavigateToNewDraft(AddNewCaseButtonComponent), actionCreators, undefined);

export { c as AddNewCaseButton };
